/**
 * SimRpcClient - AtomRpc integration for the admin Simulator endpoints (FM-157).
 *
 * Mirrors the other admin AtomRpc clients (see `AdminPersonaRpcClient.ts`):
 * `AtomRpc.Tag` gives the route atoms `.runtime.atom(...)` for the polling
 * reads (`sim.listRuns`, `sim.runDetail`) and `.runtime.fn(...)` for the
 * cockpit / batch mutations (`sim.startManual`, `sim.sendTurn`,
 * `sim.finishRun`, `sim.startRuns`). Every RPC in the group is admin-gated by
 * `AdminMiddleware` server-side, so the Clerk token getter is all the client
 * plumbing needs.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { SimRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class SimRpcClient extends AtomRpc.Tag<SimRpcClient>()(
  "SimRpcClient",
  {
    group: SimRpcs,
    protocol: makeRpcClientLayer(SimRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
